// import React from "react";
// import { Home } from "react-feather";
// import { Link } from "react-router-dom";
// import { Col, Container, Row } from "reactstrap";
// const Breadcrumb = ({ title, parent, children }) => {
//   return (
//     <Container fluid={true}>
//       <div className="page-header">
//         <Row>
//           <Col lg="6">
//             <div className="page-header-left">
//               <h3>
//                 {title}
//                 <small>WAGS Admin panel</small>
//               </h3>
//             </div>
//           </Col>

//           {!children && <Col lg="6">
//             <ol className="breadcrumb pull-right">
//               <li className="breadcrumb-item">
//                 <Link to="/dashboard">
//                   <Home />
//                 </Link>
//               </li>
//               <li className="breadcrumb-item">{parent}</li>
//               <li className="breadcrumb-item active">{title}</li>
//             </ol>
//           </Col>}

//           {children && children}
//         </Row>
//       </div>
//     </Container>
//   );
// };

// export default Breadcrumb;


import React from "react";
import { Home } from "react-feather";
import { Link } from "react-router-dom";

// Plain Bootstrap markup rather than reactstrap's Container/Row/Col: those are function components
// with defaultProps in reactstrap 8, which React 18.3 warns about on every page this renders on.
const Breadcrumb = ({ title, parent, children }) => {
  return (
    <div className="container-fluid">
      <div className="page-header">
        <div className="row align-items-center">

          {/* Left: Title */}
          <div className="col d-flex align-items-center">
            <h3 className="mb-0">
              {title} <small>WAGS Admin panel</small>
            </h3>
          </div>

          {/* Right: Breadcrumb / Custom Children */}
          <div className="col d-flex justify-content-end align-items-center">
            {children ? (
              children
            ) : (
              <ol className="breadcrumb mb-0">
                <li className="breadcrumb-item">
                  <Link to="/dashboard">
                    <Home />
                  </Link>
                </li>
                <li className="breadcrumb-item">{parent}</li>
                <li className="breadcrumb-item active">{title}</li>
              </ol>
            )}
          </div>

        </div>
      </div>
    </div>
  );
};

export default Breadcrumb;




